import { useCallback, useEffect, useMemo, useState } from "react";
import Link from '../../../../components/Link'

import Grid from "../../../../components/Grid";
import Row from "../../../../components/Grid/Row";
import Col from "../../../../components/Grid/Col";
import Icon from "../../../../components/Icon";
import Filters from "./components/Filters";
import CommunityMembersList from "./components/CommunityMembersList";

import Tabs from "../components/Tabs";
import { connect, useDispatch } from "react-redux";
import {
  exportCommunitySubscribers,
  getCommunitySubscribers,
} from "../../../../store/actions/community";
import { getPosts } from "../../../../store/actions/post";
import { Group } from "../../../../types";
import PreDifusion from "./components/PreDifusion";
import { PaginationInDto } from "../../../../types/pagination";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { useLayout } from "../../../../providers/LayoutProvider";
import { Center } from "../../../../components/StyledComponents";
import leadMagnetIcon from "../../../../assets/icons/target.svg";
import { GetPostsOutDto } from "../../../../types/post";
import { MembersSummaryCard, MembersCount, Button } from "./styles";
import { getUrlParamByName } from "../../../../helpers/get-url-param";
import FloatingMenu from "./components/FloatingMenu";
interface ComponentProps {
  groups: Group[];
  community: Group;
  communityStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  communitySubscribers: {
    pagination: PaginationInDto;
    data: any[];
  };
  communitySubscribersStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  posts?: any;
  postsStates?: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
}

export interface Option {
  value: string | number;
  label: string;
  group_type?: string;
}

export interface GroupedOptions {
  label: string;
  options: Option[];
}

export interface Filter {
  condition: string;
  value: string | number | boolean;
}



const Component = ({
  groups,
  community,
  communityStates,
  communitySubscribers,
  communitySubscribersStates,
  posts,
  postsStates,
}: ComponentProps) => {
  const dispatch = useDispatch();
  const { layout, setLayout } = useLayout();
  const { isMobile } = useWindowSize();
  const [preDifusionVisible, setPreDifusionVisible] = useState<boolean>(false);
  const [sortBy, setSortBy] = useState<string>();
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [filters, setFilters] = useState<any>({});
  const [autoFiltersApplied, setAutoFiltersApplied] = useState<boolean>(false);

  // Handlers para el componente Filters
  const handleSubmitFilters = (values: any) => {
    console.log('handleSubmitFilters called with:', JSON.stringify(values));

    const apiFilters: any = {};

    // Agregar sort y sort direction
    if (sortBy) {
      apiFilters._sort = sortDirection;
      apiFilters._sort_by = sortBy;
    }

    // Determinar si es "in" o "not_in" basado en participation_type
    const isIn = values.participation_type === 'in';
    const groupKey = isIn ? 'group_id_in' : 'group_id_not_in';
    const leadMagnetKey = isIn ? 'lead_magnets_id_in' : 'lead_magnets_id_not_in';

    // Recolectar IDs de grupos (experiences, memberships, free_experiences)
    const groupIds: number[] = [];
    if (values.membership && values.membership.length > 0) {
      groupIds.push(...values.membership);
    }
    if (values.experience && values.experience.length > 0) {
      groupIds.push(...values.experience);
    }
    if (values.free_experience && values.free_experience.length > 0) {
      groupIds.push(...values.free_experience);
    }

    // Agregar group_id_in/group_id_not_in si hay IDs
    if (groupIds.length > 0) {
      apiFilters[groupKey] = groupIds;
    }

    // Agregar lead_magnets_id_in/lead_magnets_id_not_in si hay lead magnets
    if (values.lead_magnet && values.lead_magnet.length > 0) {
      apiFilters[leadMagnetKey] = values.lead_magnet;
    }

    // Agregar filtros de group_type según los valores seleccionados
    if (values.group_type && values.group_type.length > 0) {
      values.group_type.forEach((groupType: string) => {
        switch (groupType) {
          case 'all_group_types_gt':
            apiFilters.all_group_types_gt = '1';
            break;
          case 'experiences_gt':
            apiFilters.experiences_gt = '1';
            break;
          case 'free_experiences_gt':
            apiFilters.free_experiences_gt = '1';
            break;
          case 'membership_gt':
            apiFilters.membership_gt = '1';
            break;
          case 'lead_magnets_gt':
            apiFilters.lead_magnets_gt = '1';
            break;
          default:
            console.warn(`Tipo de grupo no reconocido: ${groupType}`);
        }
      });
    }

    setFilters(apiFilters);
    console.log('API filters:', apiFilters);

    // Aquí puedes usar apiFilters para hacer la llamada a la API
    // dispatch(getCommunitySubscribers(apiFilters));
  };

  const paginate = useCallback((page) => {
    if (community?.expert) {
      dispatch(
        getCommunitySubscribers({
          filters,
          pagination: { page, per_parge: 20, _sort: sortDirection, _sort_by: sortBy },
          group_id: community?.expert?.id,
        })
      );
    }
  }, [community, filters, sortDirection, sortBy])

  const exportSubscribers = () => {
    dispatch(
      exportCommunitySubscribers({ filters, group_id: community?.expert?.id })
    );
  };



  useEffect(() => {
    setLayout({
      ...layout,
      page: {
        title: "Tu Audiencia",
        description: "Listado de miembros de la comunidad",
      },
      dashboard: {
        tabs: {
          visible: true,
          activeTab: "members",
          component: [<Tabs active="members" />],
        },
      },
      header: {
        visible: true,
        actions: !isMobile ? [
          <Link
            href={`/dashboard/community/${community?.id}/lead-magnets/new`}
            options={{ size: "lg", type: "filled", skin: "purple" }}
            style={{ minWidth: "210px", gap: 10 }}
          >
            <Icon icon={leadMagnetIcon} size="24px" color="white" />
            Crear Lead Magnet
          </Link>,
          // <Button
          //   onClick={() => dispatch(showModal("modal-importar-miembros"))}
          //   options={{
          //     size: "lg",
          //     type: "filled",
          //     skin: "purple",
          //   }}
          //   style={{ minWidth: "210px" }}
          // >
          //   Importar miembros
          // </Button>,
        ] : [],
      },
      show_whatsapp: !isMobile,
    });
  }, [community, isMobile]);

  useEffect(() => {
    paginate(1);
  }, [sortBy, sortDirection, filters]);

  useEffect(() => {
    paginate(1);
  }, [community]);

  // Get all community posts
  useEffect(() => {
    const communityGroupId = groups?.find(group => group.group_type === 'community')?.id;

    if (communityGroupId) {
      const payload: GetPostsOutDto = {
        filters: {
          enrich_user_access_data: true,
          group_id: communityGroupId
        },
        pagination: { page: 1, per_parge: 100 }
      };
      dispatch(getPosts(payload));
    }
  }, [groups])

  // Auto-configure filters if lead_magnet_id is present in URL
  useEffect(() => {
    if (!autoFiltersApplied && groups && posts) {
      const leadMagnetId = getUrlParamByName('lead_magnet_id');

      if (leadMagnetId) {
        const leadMagnetIdNumber = parseInt(leadMagnetId, 10);

        if (!isNaN(leadMagnetIdNumber)) {
          // Configure automatic filters
          const autoFilters = {
            participation_type: 'in',
            group_type: ['lead_magnets_gt'],
            lead_magnet: [leadMagnetIdNumber]
          };

          // Submit the filters automatically
          handleSubmitFilters(autoFilters);
          setAutoFiltersApplied(true);
        }
      }
    }
  }, [groups, posts, autoFiltersApplied]);

  return (
    <>
      <Grid.Container>
        <Row>
          <Col>
            <Filters
              onSubmit={handleSubmitFilters}
              autoFiltersApplied={autoFiltersApplied}
            />

            <MembersSummaryCard>
              <Center horizontal="space" vertical="center" column={isMobile} gap={10}>
                <MembersCount>
                  {communitySubscribers?.pagination?.total} miembros
                </MembersCount>

                {!isMobile && <Center
                  horizontal={isMobile ? "space" : "right"}
                  vertical="center"
                  gap={12}
                >
                  <Button
                    onClick={() => setPreDifusionVisible(!preDifusionVisible)}
                    options={{ size: "lg", type: "link", skin: "purple" }}
                  >
                    Copiar los e-mails {!isMobile ? `(${communitySubscribers?.pagination?.total})` : ""}
                  </Button>

                  <Button
                    onClick={() => exportSubscribers()}
                    options={{ size: "lg", type: "link", skin: "purple" }}
                  >
                    Exportar {!isMobile ? "listado" : ""}
                  </Button>
                </Center>}
              </Center>
            </MembersSummaryCard>

            <div style={{ height: "6px" }} />

            <CommunityMembersList
              groupId={community?.expert?.id}
              states={communitySubscribersStates}
              data={communitySubscribers?.data || []}
              filters={filters}
              pagination={communitySubscribers?.pagination}
              goToPage={paginate}
              sortBy={sortBy}
              sortDirection={sortDirection}
              onSort={(dataIndex) => {
                setSortBy(dataIndex);
                setSortDirection(sortDirection === "asc" ? "desc" : "asc");
              }}
            />
          </Col>
        </Row>
      </Grid.Container>

      <FloatingMenu
        setPreDifusionVisible={() => setPreDifusionVisible(!preDifusionVisible)}
        exportSubscribers={() => exportSubscribers()}
      />

      <PreDifusion
        appliedFilters={{
          filters,
          group_id: community?.expert?.id,
        }}
        visible={preDifusionVisible}
        setVisible={setPreDifusionVisible}
        onClose={() => { }}
      />
    </>
  );
};

const state = ({ communityStore, userStore, groupStore, postStore }) => {
  const { data: userInformation } = userStore.information;
  const { data: groups } = userStore.groups;
  const { data: communitySubscribers, states: communitySubscribersStates } =
    communityStore.subscribers;
  const { data: community, states: communityStates } = communityStore.community;
  const { data: posts, states: postsStates } = postStore.listPosts;

  return {
    userInformation,
    communitySubscribers,
    communitySubscribersStates,
    community,
    communityStates,
    groups,
    posts,
    postsStates,
  };
};

export default connect(state)(Component);
